/**
 * 接口并发处理
 * 场景：相同参数的接口并发请求时，只请求一次，待请求成功后统一返回结果。
 * 用法：
 *  const api = superveneApi((params)=> request.get('url', params));
 *  api(params).then(res=>{});
 * @param apiFn
 * @returns {function(...[*]): Promise<unknown>}
 */
export function superveneApi(apiFn) {
  let resolveCallBacks = [];
  let rejectCallBacks = [];
  let isRequesting = false;
  return (...ext) => {
    return new Promise((resolve, reject) => {
      resolveCallBacks.push(resolve);
      rejectCallBacks.push(reject);
      if (isRequesting) return;
      isRequesting = true;
      apiFn(...ext)
        .then((res) => {
          resolveCallBacks.forEach((fn) => {
            fn(res);
          });
        })
        .catch((err) => {
          rejectCallBacks.forEach((fn) => {
            fn(err);
          });
        })
        .finally(() => {
          resolveCallBacks = [];
          rejectCallBacks = [];
          isRequesting = false;
        });
    });
  };
}
